"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StringManipulator_1 = require("../../../_Core/StringManipulator");
var Theme_1 = require("../../../Theme/");
var StatusMarker_styles_1 = require("../StatusMarker.styles");
var buildColour = function (status, hierarchy) {
    if (hierarchy === "Primary") {
        switch (status) {
            case "Departed":
                return { ColorScheme: Theme_1.Color.Grey.Light };
            case "Reservation":
                return { ColorScheme: Theme_1.Color.Purple.Dark };
            case "Arrived":
                return { ColorScheme: Theme_1.Color.Blue.Dark };
            case "Cancelled":
                return { ColorScheme: Theme_1.Color.Grey.Light };
            case "OverdueArrival":
            case "OverdueDeparture":
                return { ColorScheme: Theme_1.Color.Orange.Dark };
        }
    }
    else {
        switch (status) {
            case "Departed":
                return { ColorScheme: Theme_1.Color.Grey.Lighter };
            case "Reservation":
                return { ColorScheme: Theme_1.Color.Purple.Light };
            case "Arrived":
                return { ColorScheme: Theme_1.Color.Blue.Light };
            case "Cancelled":
                return { ColorScheme: Theme_1.Color.Grey.Lighter };
            case "OverdueArrival":
            case "OverdueDeparture":
                return { ColorScheme: Theme_1.Color.Orange.Light };
        }
    }
};
exports.default = (function (_a) {
    var Value = _a.Status, _b = _a.Hierarchy, Hierarchy = _b === void 0 ? "Primary" : _b;
    return (React.createElement(StatusMarker_styles_1.StatusMarker, __assign({}, buildColour(Value, Hierarchy)), StringManipulator_1.PascalCaseToTitleCase(Value)));
});
